import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DialogComponent } from '@app/shared/dialog/dialog-component.directive';
import { BootstrapSemanticVariation } from '@app/utils/bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

interface InfoDialogInput {
  content: string;
  title: string;
  variant?: BootstrapSemanticVariation;
}

@Component({
  selector: 'portal-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
  standalone: false,
})
export class InfoDialogComponent
  extends DialogComponent<InfoDialogInput, void>
  implements InfoDialogInput, OnInit
{
  content: string;
  title: string;
  variant?: BootstrapSemanticVariation;

  html: SafeHtml;

  constructor(
    private sanitizer: DomSanitizer,
    ngbActiveModal: NgbActiveModal
  ) {
    super(ngbActiveModal);
  }

  ngOnInit() {
    this.html = this.sanitizer.bypassSecurityTrustHtml(this.content);
  }
}
